/* eslint-disable jsx-a11y/media-has-caption */
import React from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@mui/styles/makeStyles';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Webcam from 'react-webcam';

import Styles from './styles';

const useStyles = makeStyles(Styles);

function VideoPreview({ videoDeviceId, cameraEnabled }) {
  const { t } = useTranslation('labels');
  const classes = useStyles();

  return (
    <div data-testid="videoPreview" className={classes.backdrop} id="local-media">
      {cameraEnabled && videoDeviceId && <Webcam className={classes.webcamVideo} audio={false} videoConstraints={{ deviceId: videoDeviceId }} />}
      {(!cameraEnabled || !videoDeviceId.length) && (
        <div className={classes.cameraAccessDenied}>
          <div className={classes.info}>
            <Typography sx={{ textTransform: 'capitalize' }} variant="body2" component="span">
              {t(!cameraEnabled ? 'camera_access_denied' : 'camera_turned_off')}
            </Typography>
            <Typography variant="caption" component="span">
              {t(!cameraEnabled ? 'please_allow_browser_access_to_your_camera' : 'please_switch_the_camera_on')}
            </Typography>
          </div>
        </div>
      )}
    </div>
  );
}

VideoPreview.propTypes = {
  cameraEnabled: PropTypes.bool.isRequired,
  videoDeviceId: PropTypes.string.isRequired,
};

export default VideoPreview;
